import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ConsentState, RootState } from 'types/state'

export type ConsentStatus = 'granted' | 'denied' | 'pending'

const initialState: ConsentState = {
  analytics: null,
  bannerEnabled: false,
  bannerResolved: false,
}

export const consentSlice = createSlice({
  name: 'consent',
  initialState,
  reducers: {
    setAnalyticsConsent: (state: ConsentState, { payload }: PayloadAction<boolean>) => {
      state.analytics = payload
    },
    setCookieBannerEnabled: (state: ConsentState, { payload }: PayloadAction<boolean>) => {
      state.bannerEnabled = payload
      state.bannerResolved = true
    },
  },
})

export const consentActions = consentSlice.actions
export default consentSlice.reducer

export const consentSelectors = {
  analytics: (state: RootState) => state.consentState.analytics,
  bannerEnabled: (state: RootState) => state.consentState.bannerEnabled,
  decided: (state: RootState) => state.consentState.analytics !== null,
  status: (state: RootState): ConsentStatus => {
    const { analytics, bannerEnabled, bannerResolved } = state.consentState
    if (analytics === true) return 'granted'
    if (analytics === false) return 'denied'
    if (!bannerResolved) return 'pending'
    return bannerEnabled ? 'pending' : 'granted'
  },
  analyticsAllowed: (state: RootState) => consentSelectors.status(state) === 'granted',
}
